import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { languageswitchConstants } from '../constants';
import { SocialMediaListRender } from './SocialMediaListRender';


export const SocialMediaListFR = () => {
    const dispatch = useDispatch();
    const s = useSelector(state => state.socialmediaFR.socialmediaListFR);
    const [socialmediaListFR, setSocialmedialListFR] = useState(s);
    const loading = useSelector(state => state.socialmediaFR.loading);
    const e = useSelector(state => state.socialmediaFR.error);
    const [error, setError] = useState(e);
    const d = useSelector(state => state.socialmediaFR.done);
    const [done, setDone] = useState(d);
    var dataLimitPerPage = 15;

    const lang = useSelector(state => state.languageswitch);
    if (lang === languageswitchConstants.FRANCAIS_NR) {
        return <SocialMediaListRender
            stateList={s}
            socialmediaList={socialmediaListFR}
            setSocialmedialList={setSocialmedialListFR}
            loading={loading}
            errorState={e}
            error={error}
            setError={setError}
            doneState={d}
            done={done}
            setDone={setDone}
            dataLimitPerPage={dataLimitPerPage}
        />
    }
}